import { render, staticRenderFns } from "./textareaOne.vue?vue&type=template&id=0c9b74cc&scoped=true"
import script from "./textareaOne.vue?vue&type=script&lang=js"
export * from "./textareaOne.vue?vue&type=script&lang=js"
import style0 from "./textareaOne.vue?vue&type=style&index=0&id=0c9b74cc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9b74cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zhenzhaopin\\xxh-zhaopin-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c9b74cc')) {
      api.createRecord('0c9b74cc', component.options)
    } else {
      api.reload('0c9b74cc', component.options)
    }
    module.hot.accept("./textareaOne.vue?vue&type=template&id=0c9b74cc&scoped=true", function () {
      api.rerender('0c9b74cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/aiChat/components/customTextArea/templates/textareaOne.vue"
export default component.exports